import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import Component from "../components/Component/component"
import PostHeader from "../components/PostHeader/postHeader"
import SEO from "../components/seo"

export default ({ data }) => {
  return (
    <Layout active_navigation={"true"}>
      <SEO
        title={data.allContentstackPosts.edges[0].node.seo.title}
        description={data.allContentstackPosts.edges[0].node.seo.description}
        canonical={data.allContentstackPosts.edges[0].node.seo.canonical}
      />
      <div className="container component__container product-page">
        <PostHeader
          headline={data.allContentstackPosts.edges[0].node.title}
          share={true}
        />
        <Component
          __typename={"Contentstack_rich_text_component"}
          background_image={null}
          background_color={"white"}
          color_theme={"light"}
          rich_text_editor={
            data.allContentstackPosts.edges[0].node.full_description
          }
          // TODO: REMOVE DEPENDENCY
          button={[]}
        />
      </div>
    </Layout>
  )
}

export const query = graphql`
  query($title: String!) {
    allContentstackPosts(filter: { title: { eq: $title } }) {
      edges {
        node {
          title
          date
          full_description
          seo {
            title
            description
            canonical
          }
        }
      }
    }
  }
`
